import { render, staticRenderFns } from "./RflmSpouseSupportOrder.vue?vue&type=template&id=66e7595a"
import script from "./RflmSpouseSupportOrder.vue?vue&type=script&lang=ts"
export * from "./RflmSpouseSupportOrder.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports